module.exports = __webpack_public_path__ + "static/media/apple.0862e912.svg";